function Eritrea({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1135)">
        <path d="M14.6087 14.6089C14.6087 14.6089 4.69565 27.3162 4.68628 27.3139C7.58165 30.2093 11.5817 32.0002 16 32.0002C24.8365 32.0002 32 24.8367 32 16.0002L14.6087 14.6089Z" fill="#338AF3"/>
        <path d="M14.6087 16C14.6087 16 4.69565 4.68406 4.68628 4.68631C7.58165 1.79088 11.5817 0 16 0C24.8365 0 32 7.1635 32 16H14.6087Z" fill="#6DA544"/>
        <path d="M4.68628 4.68604C-1.56209 10.9344 -1.56209 21.0651 4.68628 27.3135C4.68584 27.3161 32 15.9998 32 15.9998L4.68628 4.68604Z" fill="#D80027"/>
        <path d="M8.34778 9.39111C5.27909 9.39111 2.78259 11.8877 2.78259 14.9563V17.0432C2.78259 20.1119 5.27915 22.6084 8.34778 22.6084C11.4164 22.6084 13.913 20.1119 13.913 17.0432V14.9563C13.913 11.8877 11.4165 9.39111 8.34778 9.39111ZM11.826 17.0433C11.826 18.5978 10.8009 19.9171 9.39121 20.3614V18.0868L10.8677 16.6103L9.39203 15.1346L9.39121 14.6094V13.9129H7.30434V15.9998L5.82884 17.4752L7.30434 18.9507V20.3615C5.89465 19.9172 4.86953 18.5979 4.86953 17.0434V14.9564C4.86953 13.0385 6.4299 11.4782 8.34778 11.4782C10.2657 11.4782 11.826 13.0386 11.826 14.9564V17.0433Z" fill="#FFDA44"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Eritrea;
